import { useState, useEffect } from "react";
import TreeCare from "./TreeCare";
import { useDispatch, useSelector } from 'react-redux';
import RequisitionAction from '../../../../../../../Store/Component/Requisition/RequisitionAction'

const TreeCareContainer = (props?:any) => {
  const managedEquipRef = props?.managedEquipRef
  const dispatch = useDispatch();
  
  const [manufacturerDropDownList, setManufacturerDropDownList] = useState<any>([]);
  const [equipmentTypeDropDownList, setEquipmentTypeDropDownList] = useState<any>([]);
  const [horsePowerDropDownList, setHorsePowerDropDownList] = useState<any>([]);
  const [fuelTypeDropDownList, setFuelTypeDropDownList] = useState<any>([]);

  const { managedEquipmentDropDown, managedEquipmentValues, editRequestDetails, isEditRequestClick }: any = useSelector((state? : any) => ({
    managedEquipmentDropDown: state.ManagedEquipmentDropDownReducer.managedEquipmentDropDown,
    managedEquipmentValues: state.RequisitionReducer.managedEquipmentValues,
    editRequestDetails: state.RequisitionReducer.editRequestDetails,
    isEditRequestClick: state.RequisitionReducer.isEditRequestClick,
  }));

  ///Modified dropDown values as required
  useEffect(()=>{
    if (managedEquipmentDropDown?.length > 0) {
      managedEquipmentDropDown?.map((item: any) => {
        if (item?.dropdownName == "Manufacturer") {
          const defaultManufacturerOption = {
            text: "Select Manufacturer",
            value: null
        };
        item?.dropdownList?.unshift(defaultManufacturerOption);
          let manufacturerDropdownListTemp = item?.dropdownList?.map((val: any) =>
            ({ text: val.text, value: val.value, label: val.text, key: val.value })
          );
          setManufacturerDropDownList(manufacturerDropdownListTemp)
        } else if (item?.dropdownName == "Equipment Type") {
          const defaultEquipmentTypeOption = {
            text: "Select Equipment Type",
            value: null
        };
        item?.dropdownList?.unshift(defaultEquipmentTypeOption);
        let equipmentTypeDropdownListTemp = item?.dropdownList?.map((val: any) =>
            ({ text: val.text, value: val.value, label: val.text, key: val.value })
          );
          setEquipmentTypeDropDownList(equipmentTypeDropdownListTemp)
        }else if (item?.dropdownName == "Horse Power") {
          const defaultHorsePowerOption = {
            text: "Select Horse Power",
            value: null
        };
        item?.dropdownList?.unshift(defaultHorsePowerOption);
        let horsePowerDropdownListTemp = item?.dropdownList?.map((val: any) =>
            ({ text: val.text, value: val.value, label: val.text, key: val.value })
          );
          setHorsePowerDropDownList(horsePowerDropdownListTemp)
        }else if (item?.dropdownName == "Fuel Type") {
          const defaultFuelTypeOption = {
            text: "Select Fuel Type",
            value: null
        };
        item?.dropdownList?.unshift(defaultFuelTypeOption);
        let fuelTypeDropdownListTemp = item?.dropdownList?.map((val: any) =>
            ({ text: val.text, value: val.value, label: val.text, key: val.value })
          );
          setFuelTypeDropDownList(fuelTypeDropdownListTemp)
        }
      })
    }
  },[managedEquipmentDropDown])

  useEffect(()=> {
    if (isEditRequestClick) {
      let managedEquipmentValuesTemp: any = {}
      let selectedManufacturer: any = ""
      let selectedTreeCareEquipmentType: any = ""
      let selectedHorsePower: any = ""
      let selectedFuelType: any = ""
      
      if (editRequestDetails?.manufacturer && manufacturerDropDownList?.length > 0) {
        selectedManufacturer = manufacturerDropDownList?.find((option: any) => option?.value === editRequestDetails?.manufacturer)
      }

      if (editRequestDetails?.treeCareEquipmentType && equipmentTypeDropDownList?.length > 0) {
        selectedTreeCareEquipmentType = equipmentTypeDropDownList?.find((option: any) => option?.value === editRequestDetails?.treeCareEquipmentType)
      }

      if (editRequestDetails?.horsePower && horsePowerDropDownList?.length > 0) {
        selectedHorsePower = horsePowerDropDownList?.find((option: any) => option?.value === editRequestDetails?.horsePower)
      }

      if (editRequestDetails?.fuelType && fuelTypeDropDownList?.length > 0) {
        selectedFuelType = fuelTypeDropDownList?.find((option: any) => option?.value === editRequestDetails?.fuelType)
      }

      managedEquipmentValuesTemp = { 
        ...managedEquipmentValues, 
        manufacturer: selectedManufacturer, 
        treeCareEquipmentType: selectedTreeCareEquipmentType,
        horsePower: selectedHorsePower,
        fuelType: selectedFuelType,
      }
      dispatch(RequisitionAction.setManagedEquipmentValues(managedEquipmentValuesTemp))
    }
  }, [isEditRequestClick, manufacturerDropDownList, equipmentTypeDropDownList, horsePowerDropDownList, fuelTypeDropDownList])
  
useEffect(()=> {
  managedEquipRef.current[1]?.focus()
},[])

const handleManufacturerChange = (e:any,item:any,name:string) => {
  dispatch(RequisitionAction.setManagedEquipmentValues({
    ...managedEquipmentValues,
    [name]: item
}));
  if(item.label  !== 'Select Manufacturer') {
    managedEquipRef.current[2]?.focus()

  }
}
const handleEquipmentTypeChange= (e:any,item:any,name:string) => {
  dispatch(RequisitionAction.setManagedEquipmentValues({
    ...managedEquipmentValues,
    [name]: item
}));
  if(item.label  !== 'Select Equipment Type') {
    managedEquipRef.current[3]?.focus()
  }
}
const handleHorsePowerChange = (e:any,item:any,name:string) => {
  dispatch(RequisitionAction.setManagedEquipmentValues({
    ...managedEquipmentValues,
    [name]: item
}));
  if(item.label  !== 'Select Horse Power') {
    managedEquipRef.current[4]?.focus()
  }
}
const handleFuelTypeChange= (e:any,item:any,name:string)=> {
  dispatch(RequisitionAction.setManagedEquipmentValues({
    ...managedEquipmentValues,
    [name]: item
}));
  if(item.label  !== 'Select Fuel Type') {
    managedEquipRef.current[8]?.focus()
  }
}
  return (
    <TreeCare
        managedEquipmentValues={managedEquipmentValues}
        equipmentTypeDropDownList={equipmentTypeDropDownList}
        manufacturerDropDownList={manufacturerDropDownList}
        horsePowerDropDownList={horsePowerDropDownList}
        fuelTypeDropDownList={fuelTypeDropDownList}
        managedEquipRef={managedEquipRef}
        handleManufacturerChange={handleManufacturerChange}
        handleEquipmentTypeChange={handleEquipmentTypeChange}
        handleHorsePowerChange={handleHorsePowerChange}
        handleFuelTypeChange={handleFuelTypeChange}
    />
  )
}

export default TreeCareContainer;
